export default {
  constants: {
    APP: "DEC",
    KEY: "2mwTEDr9zXJH323M",
  },

  // apiGateway: {
  //   //DEV
  //   REGION: 'us-east-1',
  //   URL: 'https://dev.smartstakeapi.com/',
  //   GA_ID: "UA-169004578-1",
  //   ENV: "dev",
  //   NETWORK: "stakingService",
  //   DEFAULT_POOL_ID: 1,
  //   CHAIN_ID: "mainnet",
  //   URL_SPECIAL: 'https://prod.smartstakeapi.com/',
  // },

  apiGateway: {
    //PROD
    REGION: 'us-east-1',
    URL: 'https://prod.smartstakeapi.com/',
    GA_ID: "UA-169004578-1",
    ENV: "prod",
    NETWORK: "stakingService",
    DEFAULT_POOL_ID: 1,
    CHAIN_ID: "mainnet",
    URL_SPECIAL: 'https://prod.smartstakeapi.com/',
  },
};



// WEBPACK FOOTER //
// ./src/config.js